import {SharedInitGuard} from '@shared/guards/shared-init.guard';
import {Route} from '@angular/router';

export const getSharedLoginRoutes = (): Route[] => [
  {
    path: 'init',
    canActivate: [SharedInitGuard],
    loadComponent: () => import('@shared/components/login/pages/init/shared-init.page').then(m => m.SharedInitPage),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@shared/components/login/pages/reset-password/shared-reset-password.page').then(m => m.SharedResetPasswordPage),
  },
  {
    path: 'change-password',
    loadComponent: () => import('@shared/components/login/pages/change-password/shared-change-password.page').then(m => m.SharedChangePasswordPage),
  }
];
